export enum LifetimeLimitAckType {
  Initial = 1,
  Annual = 2
}
